import { clearEmbedTokens } from './embedTokenManager';

export const clearStorage = () => {
  clearEmbedTokens();
  localStorage.removeItem('iframeToken');
  localStorage.clear();
  navigateTo('/auth');
};

export const checkTokenExpiration = () => {
  const token = localStorage.getItem('token');
  if (token) {
    const { exp } = jwtDecode(token);
    if (Date.now() >= exp * 1000) {
      clearStorage();
    }
  }
};
